import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IModal } from 'services/modal';
import { Button } from 'components/parts';
import { executeCache } from 'api/cache/execute-cache.api';
import { useSubscription } from 'hooks/use-subscription.hook';
import { addToast } from 'services/toast';
import { getMasterData } from 'services/master-data';
import { _masterDataObsStore } from 'services/master-data/get-master-data.service';

function ModalClearCache(props: IModal) {
  const { modalRef } = props;
  const subscription = useSubscription();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    const getClearCacheSub = executeCache('clear_master_cache').subscribe({
      next: () => {
        _masterDataObsStore['masterData'] = {};
        getMasterData('masterData').subscribe(() => {
          navigate(window.location.pathname + window.location.search, { replace: true });
        });

        addToast({
          title: t('MS17'),
        });
        modalRef.close();
      },
    });

    subscription.add(getClearCacheSub);
  }, [subscription, t, modalRef, navigate]);

  return (
    <div className='modal-content'>
      <div className='modal-header'>
        <div className='modal-title h4'>{t('page.cache.label.clear_cache')}</div>
      </div>
      <div className='modal-body'>{t('MS35', { field: t('sidebar.menu.clear_cache.title') })}</div>
      <div className='modal-footer'>
        <Button type='button' theme='danger' className='h-mr-8' onClick={modalRef.close}>
          {t('common.btn.cancel')}
        </Button>
        <Button type='submit' onClick={onSubmit}>
          {t('common.btn.confirm')}
        </Button>
      </div>
    </div>
  );
}

export default ModalClearCache;
